import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=4b1887c4&scoped=true&"
import script from "./PaymentsView.vue?vue&type=script&lang=js&"
export * from "./PaymentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1887c4",
  null
  
)

export default component.exports